"use client";

import { useCallback, useRef } from "react";
import { useCommsPanel } from "./CommsProvider";

export function ResizeHandle() {
  const { setPanelWidth } = useCommsPanel();
  const dragging = useRef(false);

  const onMouseDown = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      dragging.current = true;
      const startX = e.clientX;
      const startWidth = document.querySelector("[data-comms-panel]")?.getBoundingClientRect().width ?? 440;

      function onMouseMove(ev: MouseEvent) {
        if (!dragging.current) return;
        const delta = startX - ev.clientX;
        setPanelWidth(startWidth + delta);
      }

      function onMouseUp() {
        dragging.current = false;
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
        document.body.style.cursor = "";
        document.body.style.userSelect = "";
      }

      document.addEventListener("mousemove", onMouseMove);
      document.addEventListener("mouseup", onMouseUp);
      document.body.style.cursor = "col-resize";
      document.body.style.userSelect = "none";
    },
    [setPanelWidth],
  );

  return (
    <div
      onMouseDown={onMouseDown}
      className="absolute inset-y-0 left-0 w-1 cursor-col-resize bg-transparent hover:bg-blue-400 transition-colors"
      title="Drag to resize"
    />
  );
}
